import {useMemo} from 'react';
import {isArray} from 'underscore';
import {PropertyFlowDescription, StyleAnimation} from './style-animation';
import {TransitionProps} from './transition/transition';
import {Duration} from './types';

type Props = Omit<TransitionProps, 'duration'> & {duration: Duration};

export function createStyledAnimation<T = {}>(name: string, flowBuilder: (duration: Duration, flowProps: T) => PropertyFlowDescription[], dependProps?: keyof T | (keyof T)[]) {
	const Transition = (props: Props & T) => {
		const {duration, ...otherProps} = props;

		let flowDependencies = [];
		if(dependProps) {
			if(isArray(dependProps)) {
				for (let prop of dependProps) {
					flowDependencies.push((otherProps as T)[prop]);
				}
			} else {
				flowDependencies.push((otherProps as T)[dependProps]);
			}
		}

		//Recalculate flow only when 'duration' or not related to Transition props has changed.
		const flow = useMemo(() => flowBuilder(duration, props as T), [duration, ...flowDependencies]);

		return <StyleAnimation flow={flow} {...props}/>;
	};

	(Transition as any).displayName = name;

	return Transition;
}
